import { createContext, useState, useEffect } from 'react';
import React from 'react';

export const userContext = createContext();

const ContextProvider = ({ children }) => {
  const [role, setRole] = useState('');
  const [user, setUser] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  // Function to sync auth state from storage
  const syncAuthState = () => {
    const storedUser = localStorage.getItem('user');
    const storedToken = sessionStorage.getItem('accessToken') || localStorage.getItem('accessToken');

    if (storedUser && storedToken) {
      try {
        const userData = JSON.parse(storedUser);
        setUser(userData);
        setRole(userData.role.toLowerCase());
        setAuthenticated(true);
        
        console.log('✅ User authenticated from storage:', userData.email);
        return true;
      } catch (error) {
        console.error('Error parsing user data:', error);
        // Clear corrupted data
        localStorage.removeItem('user');
        sessionStorage.removeItem('accessToken');
        localStorage.removeItem('accessToken');
        setUser(null);
        setRole('');
        setAuthenticated(false);
        return false;
      }
    } else {
      setUser(null);
      setRole('');
      setAuthenticated(false);
      return false;
    }
  };

  // Logout helper function
  const handleLogout = () => {
    setUser(null);
    setRole('');
    setAuthenticated(false);
    localStorage.removeItem('user');
    sessionStorage.removeItem('accessToken');
    localStorage.removeItem('accessToken');
    console.log('✅ User logged out from context');
  };

  // Check storage on component mount
  useEffect(() => {
    syncAuthState();
    setLoading(false);
  }, []);

  // Listen for storage changes (when Login updates storage or logout happens)
  useEffect(() => {
    const handleStorageChange = (e) => {
      // Only react to relevant storage keys
      if (!['user', 'accessToken'].includes(e.key)) {
        return;
      }
      
      console.log('📦 Storage changed:', e.key);
      syncAuthState();
    };

    // Listen for storage changes from other tabs
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return (
    <userContext.Provider
      value={{
        role,
        setRole,
        user,
        setUser,
        authenticated,
        setAuthenticated,
        loading,
        syncAuthState,
        handleLogout,
      }}
    >
      {children}
    </userContext.Provider>
  );
};

export default ContextProvider;